<script>
    // Import general mixin for shared functionality.
    import mixin from './../mixin';
    import constants from './../../constants.js';

    import SourceSet from './SourceSet.vue';

    export default {
        components: { SourceSet },
        mixins: [mixin],
        data() {
            return {
                constants: constants
            }
        },
        props: {
            item: {
                type: Object,
                required: true
            },
            type: {
                type: String,
                default: 'project'
            }
        }
    }
</script>

<template>
    <a :href="item.detailUrl" class="card is-flex is-flex-direction-column is-fullheight">
        <div class="card-image is-clipped is-relative">
            <source-set :image-sets="item.image" v-if="item.image && item.image.length" />
            <picture class="image is-clipped" v-else>
                <img src="https://placehold.co/411x294?text=world+waternet&font=pt-sans" alt="Fallback image" width="411" height="294" loading="lazy" onerror="this.onerror=null; this.style.backgroundColor='#cccccc'">
            </picture>
            <span :class="['tag', item.status === this.constants.project.status.ongoing ? 'is-primary' : 'is-green-dark']" v-if="item.status">{{ item.status }}</span>
            <span :class="['tag', item.category.categoryColorClass]" v-if="item.category">{{ item.category.name }}</span>
        </div>
        <div class="card-content is-flex-grow-1 is-flex is-flex-direction-column is-align-items-flex-start has-background-white-ter">
            <h4 v-if="item.title" class="title is-4">
                {{ item.title }}
            </h4>
            <span :class="['tag', 'mt-auto', 'mb-4', item.country.countryColorClass]" v-if="item.country && item.country.name">
                <span class="icon"><i class="fa-solid fa-location-dot"></i></span>
                <span>{{ item.country.name }}</span>
            </span>
            <div v-if="item.maturityLevel && type === constants.card.type.partner">
                <span v-if="item.maturityLevel.label">{{ item.maturityLevel.label }}: &nbsp;</span>
                <span v-if="item.maturityLevel.value">{{ item.maturityLevel.value }}</span>
            </div>
            <time v-if="item.date && type === constants.card.type.news" class="card-date" :datetime="item.date">
                {{ toDateStr(item.date) }}
            </time>
        </div>
    </a>
</template>
